import {
    Formik,
    FormikProps
} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {
    ApplicationAccount,
    ApplicationAccountFormType,
    ApplicationAccountRecordFormProps,
    ApplicationAccountStatus
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationAccountRecordFormProps) => {

    const onSubmit = (values: ApplicationAccountFormType) => {
        handleSubmit(values as ApplicationAccount);
    };

    let initialValues = {
        accountApplicationStatus: ApplicationAccountStatus.ACTIVE,
    } as ApplicationAccountFormType;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik<ApplicationAccountFormType>
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<ApplicationAccountFormType>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
